export var ISearchRequestReferrer;
(function (ISearchRequestReferrer) {
    let SearchRequestReferrerType;
    (function (SearchRequestReferrerType) {
        SearchRequestReferrerType["SEARCH_REQUEST_REFERRER_TYPE_UNKNOWN"] = "SEARCH_REQUEST_REFERRER_TYPE_UNKNOWN";
        /**
         * No referrer.
         */
        SearchRequestReferrerType["NONE"] = "NONE";
        /**
         * Avoid using this and consider adding a new value for new types of suggestions. This is a catchall just in case
         */
        SearchRequestReferrerType["SUGGESTIONS_ANY"] = "SUGGESTIONS_ANY";
        SearchRequestReferrerType["SUGGESTIONS_SEARCH_QUERIES"] = "SUGGESTIONS_SEARCH_QUERIES";
        SearchRequestReferrerType["SUGGESTIONS_CATEGORY_QUERIES"] = "SUGGESTIONS_CATEGORY_QUERIES";
        SearchRequestReferrerType["SUGGESTIONS_CATEGORIES"] = "SUGGESTIONS_CATEGORIES";
        SearchRequestReferrerType["SUGGESTIONS_BRANDS"] = "SUGGESTIONS_BRANDS";
        SearchRequestReferrerType["SUGGESTIONS_TRENDING_SEARCHES"] = "SUGGESTIONS_TRENDING_SEARCHES";
        SearchRequestReferrerType["SUGGESTIONS_RECENTLY_VIEWED_PRODUCTS"] = "SUGGESTIONS_RECENTLY_VIEWED_PRODUCTS";
        SearchRequestReferrerType["SUGGESTIONS_RECENT_SEARCHES"] = "SUGGESTIONS_RECENT_SEARCHES";
        SearchRequestReferrerType["SUGGESTIONS_SEARCH_RECOMMENDATIONS"] = "SUGGESTIONS_SEARCH_RECOMMENDATIONS";
        SearchRequestReferrerType["SUGGESTIONS_APPAREL_CATEGORIES"] = "SUGGESTIONS_APPAREL_CATEGORIES";
        SearchRequestReferrerType["SUGGESTIONS_ORDERED_BRANDS"] = "SUGGESTIONS_ORDERED_BRANDS";
        SearchRequestReferrerType["SUGGESTIONS_AUTOCOMPLETE_CATEGORIES"] = "SUGGESTIONS_AUTOCOMPLETE_CATEGORIES";
        SearchRequestReferrerType["HOMEPAGE_ANY"] = "HOMEPAGE_ANY";
        SearchRequestReferrerType["HOMEPAGE_TRENDING_SEARCHES"] = "HOMEPAGE_TRENDING_SEARCHES";
        SearchRequestReferrerType["HOMEPAGE_TRENDING_ON_FAIRE"] = "HOMEPAGE_TRENDING_ON_FAIRE";
        SearchRequestReferrerType["HOMEPAGE_RECOMMENDED_SEARCHES"] = "HOMEPAGE_RECOMMENDED_SEARCHES";
        SearchRequestReferrerType["PRODUCT_SEARCH_RELATED_SEARCHES"] = "PRODUCT_SEARCH_RELATED_SEARCHES";
        SearchRequestReferrerType["SUGGESTIONS_RECENT_SEARCHES_WITH_FILTERS"] = "SUGGESTIONS_RECENT_SEARCHES_WITH_FILTERS";
        SearchRequestReferrerType["SUGGESTIONS_SUGGESTED_SEARCHES_WITH_FILTERS"] = "SUGGESTIONS_SUGGESTED_SEARCHES_WITH_FILTERS";
        SearchRequestReferrerType["HOMEPAGE_RECENT_SEARCHES"] = "HOMEPAGE_RECENT_SEARCHES";
        SearchRequestReferrerType["HOMEPAGE_NEW_PRODUCTS_FROM_RECENT_SEARCH"] = "HOMEPAGE_NEW_PRODUCTS_FROM_RECENT_SEARCH";
        SearchRequestReferrerType["PRODUCT_SEARCH_FALLBACK_PRODUCTS"] = "PRODUCT_SEARCH_FALLBACK_PRODUCTS";
        SearchRequestReferrerType["HOMEPAGE_CATEGORIES_FOR_YOU"] = "HOMEPAGE_CATEGORIES_FOR_YOU";
        SearchRequestReferrerType["HOMEPAGE_MARKETING_BANNER"] = "HOMEPAGE_MARKETING_BANNER";
        SearchRequestReferrerType["CATEGORY_HUB_SUGGESTIONS"] = "CATEGORY_HUB_SUGGESTIONS";
        SearchRequestReferrerType["SUGGESTIONS_SEARCH_INLINE_BANNER"] = "SUGGESTIONS_SEARCH_INLINE_BANNER";
        /**
         * @deprecated
         */
        SearchRequestReferrerType["SUGGESTIONS_SUGGESTION_BANNER"] = "SUGGESTIONS_SUGGESTION_BANNER";
        SearchRequestReferrerType["PRODUCT_SEARCH_REFINED_SEARCHES"] = "PRODUCT_SEARCH_REFINED_SEARCHES";
        SearchRequestReferrerType["SUGGESTIONS_SUGGESTED_NAVIGATIONS"] = "SUGGESTIONS_SUGGESTED_NAVIGATIONS";
        SearchRequestReferrerType["SUGGESTIONS_BRAND_PAGE_SEARCH_EMPTY_STATE"] = "SUGGESTIONS_BRAND_PAGE_SEARCH_EMPTY_STATE";
        SearchRequestReferrerType["SUGGESTIONS_BRAND_PAGE_SEARCH_AUTOCOMPLETE"] = "SUGGESTIONS_BRAND_PAGE_SEARCH_AUTOCOMPLETE";
    })(SearchRequestReferrerType = ISearchRequestReferrer.SearchRequestReferrerType || (ISearchRequestReferrer.SearchRequestReferrerType = {}));
    /**
     * Return an instance of ISearchRequestReferrer with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    ISearchRequestReferrer.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
})(ISearchRequestReferrer || (ISearchRequestReferrer = {}));
